
export const State = {
  userInfo: null
}

export const Mutations = {
  saveUserInfo(state, info) {
    state.userInfo = info
  }
}

export const Actions = {
  saveUserInfo({ commit }, info) {
    sessionStorage.userInfo = JSON.stringify(info)
  },

  loadUserInfo({ commit }) {
    let userInfo = {}
    try {
      userInfo = JSON.parse(sessionStorage.userInfo)
    } catch (e) { }
    commit('saveUserInfo', userInfo)
  }
}
